import { render } from "./PFormField.vue?vue&type=template&id=8fb85b70"
import script from "./PFormField.vue?vue&type=script&lang=js"
export * from "./PFormField.vue?vue&type=script&lang=js"

import "./PFormField.vue?vue&type=style&index=0&id=8fb85b70&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__